/**
 * OS and hotkey helpers for consistent shortcut display and behavior.
 */

export function isMac() {
  if (typeof navigator === "undefined") return false;
  const p = navigator.platform || "";
  const ua = navigator.userAgent || "";
  return /Mac|iPad|iPhone|iPod/.test(p) || (!!ua && /Mac|iPad|iPhone|iPod/.test(ua));
}

/**
 * Canonical "Toggle Workspace" shortcut.
 * Uses Shift+W on all platforms (no Cmd/Ctrl) to avoid browser tab/window shortcuts.
 */
export const TOGGLE_WORKSPACE = {
  /** Labels for display in Settings */
  get labels() {
    return ["Shift", "W"];
  },
  /** Check if a keydown event matches this shortcut */
  match(e) {
    return e.shiftKey && (e.key === "w" || e.key === "W");
  },
};
